// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import '@/filters'
import '@/router/guards'
import VueMeta from 'vue-meta'

// import '@/compatibility'

// styles, icons & fonts
import 'bootstrap'
import 'font-awesome/css/font-awesome.css'
// Font awesome config
import { library } from '@fortawesome/fontawesome-svg-core'
import { faComment, faMapMarkerAlt, faArrowLeft, faBars, faSearch, faAngleDown,
  faAngleUp, faAngleDoubleUp, faTimes, faAngleRight, faAngleLeft, faChevronLeft, faChevronRight, faCar, faBuilding,
  faMobile, faBlender, faToolbox, faBoxes, faPlug, faCashRegister, faHome, faQuestionCircle, faBell,
  faUserCircle, faDollarSign, faAddressCard, faUserTimes, faCamera, faUser, faAward, faMedal, faEye, faEyeSlash, faEdit,
  faClock, faEnvelope, faGlobe, faCheck, faEllipsisV, faReply, faExclamationTriangle, faPhone, faHistory,
  faSeedling, faWrench, faShare, faUsers, faClone, faTrashAlt, faHandshake, faShoppingCart, faExternalLinkAlt, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faClock as farClock } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faFacebookF, faTwitter, faInstagram, faWhatsapp, faFacebookMessenger, faTelegramPlane }
  from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueLoadmore from 'vuejs-loadmore';

// Vue Social Sharing
import VueSocialSharing from 'vue-social-sharing'

// layout components
import TheNavbar from '@/components/layout/TheNavbar'
import LoginDialog from '@/components/layout/LoginDialog'
import LocationDialog from '@/components/layout/LocationDialog'
import Paginate from '@/components/layout/Paginate'
import TheFooter from '@/components/layout/TheFooter'

// ui components
import Cover from '@/components/ui/CoverDefault'
import Container from '@/components/ui/Container'
import EmptyResultsMessage from '@/components/ui/EmptyResultsMessage'
import SearchInputList from '@/components/ui/InputSearchList'
import SquaredButton from '@/components/ui/SquaredButton'
import ProgressBar from '@/components/ui/ProgressBar'
import CheckableText from '@/components/ui/forms/CheckableText'
import RadioTooltip from '@/components/ui/forms/RadioTooltip'
import RadioLinear from '@/components/ui/forms/RadioLinear'
import GroupSelect from '@/components/ui/forms/GroupSelect'
import CategoryGroupSelect from '@/components/ui/forms/CategoryGroupSelect'
import CheckboxTooltip from '@/components/ui/forms/CheckboxTooltip'
import InputGroup from '@/components/ui/forms/InputGroup'
import InlineCheck from '@/components/ui/forms/InlineCheck'
import RadioPrimaryStyled from '@/components/ui/forms/RadioPrimaryStyled'
import Loading from '@/components/ui/Loading'
import FlashMessage from '@/components/ui/FlashMessage'
import TooltipIcon from '@/components/ui/TooltipIcon'
import Tooltip from '@/components/ui/Tooltip'
import TabsMenuMobile from '@/components/ui/TabsMenuMobile'
import MIcon from '@/components/ui/MIcon'
import FloatingButton from '@/components/ui/FloatingButton'
import BadgeCounter from '@/components/ui/BadgeCounter'
import NotificationSign from '@/components/ui/NotificationSign'
import SkeletonBox from '@/components/ui/shapes/SkeletonBox'
import SkeletonCardSquared from '@/components/ui/shapes/SkeletonCardSquared'
import SkeletonCardWide from '@/components/ui/shapes/SkeletonCardWide'
import SkeletonSellerInfo from '@/components/ui/shapes/SkeletonSellerInfo'

import settings from '@/settings'

Object.freeze(settings)
Object.assign(window, { settings })

// Adding icons to library
library.add(faComment, faMapMarkerAlt, faArrowLeft, faBars, faSearch, faAngleDown,
  faAngleUp, faAngleDoubleUp, faTimes, faAngleRight, faAngleLeft, faChevronLeft, faChevronRight, faCar, faBuilding,
  faMobile, faBlender, faToolbox, faBoxes, faPlug, faCashRegister, faHome, faQuestionCircle, faBell, faUserCircle,
  faDollarSign, faAddressCard, faUserTimes, faCamera, faUser, faFacebook, faFacebookF, faFacebookMessenger, faTwitter,
  faInstagram, faWhatsapp, faTelegramPlane, faAward, faMedal, faEye, faEyeSlash, faEdit, faClock, farClock, faEnvelope,
  faGlobe, faCheck, faEllipsisV, faReply, faExclamationTriangle, faPhone, faHistory, faSeedling, faWrench, faShare,
  faUsers, faClone, faTrashAlt, faHandshake, faShoppingCart, faExternalLinkAlt, faSpinner)

// Adding Vue Social Sharing plugin
Vue.use(VueSocialSharing)

// register layout components
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('TheNavbar', TheNavbar)
Vue.component('LoginDialog', LoginDialog)
Vue.component('LocationDialog', LocationDialog)
Vue.component('Paginate', Paginate)
Vue.component('TheFooter', TheFooter)

// register ui components
Vue.component('Cover', Cover)
Vue.component('SearchInputList', SearchInputList)
Vue.component('Container', Container)
Vue.component('EmptyResultsMessage', EmptyResultsMessage)
Vue.component('SquaredButton', SquaredButton)
Vue.component('ProgressBar', ProgressBar)
Vue.component('CheckableText', CheckableText)
Vue.component('RadioTooltip', RadioTooltip)
Vue.component('RadioLinear', RadioLinear)
Vue.component('InlineCheck', InlineCheck)
Vue.component('GroupSelect', GroupSelect)
Vue.component('CategoryGroupSelect', CategoryGroupSelect)
Vue.component('CheckboxTooltip', CheckboxTooltip)
Vue.component('InputGroup', InputGroup)
Vue.component('Loading', Loading)
Vue.component('RadioPrimaryStyled', RadioPrimaryStyled)
Vue.component('FlashMessage', FlashMessage)
Vue.component('TooltipIcon', TooltipIcon)
Vue.component('Tooltip', Tooltip)
Vue.component('TabsMenuMobile', TabsMenuMobile)
Vue.component('m-icon', MIcon)
Vue.component('FloatingButton', FloatingButton)
Vue.component('BadgeCounter', BadgeCounter)
Vue.component('NotificationSign', NotificationSign)
Vue.component('SkeletonBox', SkeletonBox)
Vue.component('SkeletonCardSquared', SkeletonCardSquared)
Vue.component('SkeletonCardWide', SkeletonCardWide)
Vue.component('SkeletonSellerInfo', SkeletonSellerInfo)

/**
 * Filter properties according with a condition.
 *
 * @param {Object} obj original object.
 * @param {Function} condition
 * @return {Object} filtered object.
 */
Object.filter = (obj, condition) =>
  Object.keys(obj)
    .filter(key => condition(key, obj[key]))
    .reduce((res, key) => (res[key] = ({ ...res, [key]: obj[key] })), {})

Vue.config.productionTip = false

Vue.prototype.$CDN_STATIC = 'https://cdn1.maspocovendo.com'

// global variables
Vue.prototype.$SITE_NAME = 'MasPocoVendo.com'
Vue.prototype.$SITE_URL = 'https://www.maspocovendo.com'
Vue.prototype.$EXTERNAL_ADS_ENABLED = false

Vue.use(VueMeta)
Vue.use(VueLoadmore);

// Patch to make touch event listeners passive and avoid warnings
// This overrides addEventListener for touchstart, touchmove, touchend
const originalAddEventListener = EventTarget.prototype.addEventListener
EventTarget.prototype.addEventListener = function (type, listener, options) {
  // If it's a touch event and passive is not specified, force it to true
  if (['touchstart', 'touchmove', 'touchend'].includes(type)) {
    if (typeof options === 'boolean') {
      // If options is a boolean (capture), convert it to object
      options = { capture: options, passive: true }
    } else if (typeof options === 'object' && options !== null) {
      // If options is an object, add passive: true if not defined
      if (!('passive' in options)) {
        options = { ...options, passive: true }
      }
    } else {
      // If options is undefined/null, use passive: true
      options = { passive: true }
    }
  }
  return originalAddEventListener.call(this, type, listener, options)
}

Vue.mixin({
  methods: {
    /**
     * Global method to push an object to DataLayer for Google Tag Manager tracking
     * @param category Event category
     * @param action Event action
     * @param params Optional params for passing additional info to GTM
     */
    pushToDataLayer: (category, action, params = {}) => {
      store.dispatch('pushToDataLayer', {
        event: 'user-interaction',
        category,
        action,
        user_id: store.state.user.id,
        'interaction-type': false,
        ...params
      })
    }
  }
})

/* eslint-disable no-new */
window.vm = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js